import React from 'react'
import { useComplianceFrameworks } from 'src/components/async/complianceframework'
import { useInAudit } from 'src/context/AuditContext'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardFrameworkFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element | null => {
  const { data: frameworks } = useComplianceFrameworks(true)
  const { auditId } = useInAudit()
  const filterValues =
    frameworks?.getItemsList().map((framework) => ({
      value: framework.getName(),
      label: framework.getName(),
    })) || []

  if (auditId) {
    return null
  }

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_FRAMEWORK}
      filterName={FilterName.DASHBOARD_FRAMEWORK}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
